/**
 * Validate if product is ready for activity selection step
 */
export default defineNuxtRouteMiddleware(() => {});
